// Dil kodundan bayrak emojisi. Bayrak gorseli indirmek yerine bolge gostergesi
// harflerinden uretiliyor: ek dosya yok, her platformda kendi cizimiyle geliyor.
const LANGUAGE_COUNTRY = {
    af: "ZA",
    am: "ET",
    ar: "SA",
    az: "AZ",
    bg: "BG",
    bn: "BD",
    bs: "BA",
    ca: "ES",
    cs: "CZ",
    cy: "GB",
    da: "DK",
    de: "DE",
    el: "GR",
    en: "GB",
    es: "ES",
    "es-MX": "MX",
    et: "EE",
    fa: "IR",
    "fa-AF": "AF",
    fi: "FI",
    fr: "FR",
    "fr-CA": "CA",
    ga: "IE",
    gu: "IN",
    ha: "NG",
    he: "IL",
    hi: "IN",
    hr: "HR",
    ht: "HT",
    hu: "HU",
    hy: "AM",
    id: "ID",
    is: "IS",
    it: "IT",
    ja: "JP",
    ka: "GE",
    kk: "KZ",
    kn: "IN",
    ko: "KR",
    lt: "LT",
    lv: "LV",
    mk: "MK",
    ml: "IN",
    mn: "MN",
    mr: "IN",
    ms: "MY",
    mt: "MT",
    nl: "NL",
    no: "NO",
    pa: "IN",
    pl: "PL",
    ps: "AF",
    pt: "BR",
    "pt-PT": "PT",
    ro: "RO",
    ru: "RU",
    si: "LK",
    sk: "SK",
    sl: "SI",
    so: "SO",
    sq: "AL",
    sr: "RS",
    sv: "SE",
    sw: "TZ",
    ta: "IN",
    te: "IN",
    th: "TH",
    tl: "PH",
    tr: "TR",
    uk: "UA",
    ur: "PK",
    uz: "UZ",
    vi: "VN",
    zh: "CN",
    "zh-TW": "TW",
};

const REGIONAL_OFFSET = 127397; // 'A' (65) + offset = bolge gostergesi harfi

export const countryCodeForLanguage = (code) => {
    if (!code) return null;
    if (LANGUAGE_COUNTRY[code]) return LANGUAGE_COUNTRY[code];
    const base = String(code).split("-")[0];
    return LANGUAGE_COUNTRY[base] || null;
};

export const flagForLanguage = (code) => {
    const country = countryCodeForLanguage(code);
    if (!country) return "";
    return country
        .toUpperCase()
        .split("")
        .map((ch) => String.fromCodePoint(ch.charCodeAt(0) + REGIONAL_OFFSET))
        .join("");
};

export default flagForLanguage;



// WEBPACK FOOTER //
// ./src/utils/languageFlags.js